import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=211bc871&scoped=true&"
import script from "./WeChat.vue?vue&type=script&lang=js&"
export * from "./WeChat.vue?vue&type=script&lang=js&"
import style0 from "./WeChat.vue?vue&type=style&index=0&id=211bc871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211bc871",
  null
  
)

export default component.exports